/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uploading_MediaInputs */

const en_uploading_media = /** @type {(inputs: Uploading_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploading media...`)
};

const id_uploading_media = /** @type {(inputs: Uploading_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengunggah media...`)
};

/** @type {(inputs: Uploading_MediaInputs) => LocalizedString} */
const es_uploading_media = en_uploading_media;

/** @type {(inputs: Uploading_MediaInputs) => LocalizedString} */
const fr_uploading_media = en_uploading_media;

/** @type {(inputs: Uploading_MediaInputs) => LocalizedString} */
const de_uploading_media = en_uploading_media;

/** @type {(inputs: Uploading_MediaInputs) => LocalizedString} */
const ja_uploading_media = en_uploading_media;

/** @type {(inputs: Uploading_MediaInputs) => LocalizedString} */
const zh_uploading_media = en_uploading_media;

/** @type {(inputs: Uploading_MediaInputs) => LocalizedString} */
const ar_uploading_media = en_uploading_media;

/** @type {(inputs: Uploading_MediaInputs) => LocalizedString} */
const it_uploading_media = en_uploading_media;

/** @type {(inputs: Uploading_MediaInputs) => LocalizedString} */
const ru_uploading_media = en_uploading_media;

/** @type {(inputs: Uploading_MediaInputs) => LocalizedString} */
const pt_uploading_media = en_uploading_media;

/** @type {(inputs: Uploading_MediaInputs) => LocalizedString} */
const ko_uploading_media = en_uploading_media;

/**
* | output |
* | --- |
* | "Uploading media..." |
*
* @param {Uploading_MediaInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const uploading_media = /** @type {((inputs?: Uploading_MediaInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uploading_MediaInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_uploading_media(inputs)
	if (locale === "es") return es_uploading_media(inputs)
	if (locale === "fr") return fr_uploading_media(inputs)
	if (locale === "de") return de_uploading_media(inputs)
	if (locale === "ja") return ja_uploading_media(inputs)
	if (locale === "zh") return zh_uploading_media(inputs)
	if (locale === "ar") return ar_uploading_media(inputs)
	if (locale === "id") return id_uploading_media(inputs)
	if (locale === "it") return it_uploading_media(inputs)
	if (locale === "ru") return ru_uploading_media(inputs)
	if (locale === "pt") return pt_uploading_media(inputs)
	return ko_uploading_media(inputs)
});